export enum deviceTypes {
  DESKTOP = "desktop",
  PHONE = "phone",
  TABLET = "tablet",
  UNKNOWN = "unknown",
}
